import React from 'react';
import { Folder } from '@/types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolder } from '@fortawesome/free-regular-svg-icons';
import Modal from '@/Components/Modal';
import CloseIcon from '@/Components/Icons/CloseIcon';

interface FolderMoveModalProps {
    show: boolean;
    folders: Folder[];
    currentFolderId?: string | null;
    onClose: () => void;
    onMove: (folderId: string | null) => void;
}

export default function FolderMoveModal({ show, folders, currentFolderId, onClose, onMove }: FolderMoveModalProps) {
    const handleFolderClick = (folderId: string | null) => {
        if (folderId === currentFolderId) return;
        onMove(folderId);
        onClose();
    };

    return (
        <Modal show={show} onClose={onClose} maxWidth="md">
            <div className="w-full">
                <div className="flex items-center p-4 md:p-6">
                    <div className="flex-grow flex justify-between">
                        <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
                            Move to Folder
                        </h3>
                    </div>
                    <button type="button"
                            onClick={onClose}
                            className="text-gray-400 dark:text-gray-500 bg-transparent hover:bg-gray-200 dark:hover:bg-gray-700 hover:text-gray-900 dark:hover:text-gray-100 rounded-lg text-sm w-8 h-8 inline-flex justify-center items-center !outline-none"
                    >
                        <CloseIcon />
                        <span className="sr-only">Close modal</span>
                    </button>
                </div>
                <div className="px-6 pb-6">

                <div className="space-y-2">
                    <button
                        onClick={() => handleFolderClick(null)}
                        disabled={currentFolderId === null || currentFolderId === undefined}
                        className={`w-full flex items-center px-4 py-3 rounded-lg border text-left transition-all ${
                            currentFolderId === null || currentFolderId === undefined
                                ? 'bg-gray-100 dark:bg-gray-800 border-gray-200 dark:border-gray-700 text-gray-400 dark:text-gray-500 cursor-not-allowed'
                                : 'border-gray-200 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800 text-gray-700 dark:text-gray-300 cursor-pointer'
                        }`}
                    >
                        <FontAwesomeIcon
                            icon={faFolder}
                            className={`mr-3 ${currentFolderId === null || currentFolderId === undefined ? 'text-gray-400 dark:text-gray-500' : 'text-gray-500 dark:text-gray-400'}`}
                        />
                        <span>All Files</span>
                    </button>
                    {folders.map((folder) => (
                        <button
                            key={folder.id}
                            onClick={() => handleFolderClick(folder.id)}
                            disabled={currentFolderId === folder.id}
                            className={`w-full flex items-center px-4 py-3 rounded-lg border text-left transition-all ${
                                currentFolderId === folder.id
                                    ? 'bg-gray-100 dark:bg-gray-800 border-gray-200 dark:border-gray-700 text-gray-400 dark:text-gray-500 cursor-not-allowed'
                                    : 'border-gray-200 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800 text-gray-700 dark:text-gray-300 cursor-pointer'
                            }`}
                        >
                            <FontAwesomeIcon
                                icon={faFolder}
                                className={`mr-3 ${currentFolderId === folder.id ? 'text-gray-400 dark:text-gray-500' : 'text-gray-500 dark:text-gray-400'}`}
                            />
                            <span>{folder.name}</span>
                        </button>
                    ))}
                </div>
                </div>
            </div>
        </Modal>
    );
}
